import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchCompany, updateCompany } from '../api';

export const KEY_COMPANY = ['company'] as const;

export const useCompany = () =>
  useQuery({ queryKey: KEY_COMPANY, queryFn: fetchCompany, staleTime: 60_000 });

export function useUpdateCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateCompany,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY_COMPANY }),
  });
}
